/* unplugin-vue-components disabled */import { render } from "./ImagesBox.vue?vue&type=template&id=916ac244&ts=true"
import script from "./ImagesBox.vue?vue&type=script&lang=ts"
export * from "./ImagesBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__